import { render } from "./DraftFilter.vue?vue&type=template&id=55f79b9a"
import script from "./DraftFilter.vue?vue&type=script&lang=js"
export * from "./DraftFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__